export const config = {
  apiUrl: import.meta.env.VITE_MANAGEMENT_API_URL,
  authApiUrl: import.meta.env.VITE_MANAGEMENT_AUTH_API_URL,
  appName: import.meta.env.VITE_APP_NAME || 'Financial Gateway',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
} as const;